import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress"; // Assuming Material UI

function Loader() {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  // Handle the Redux side effect safely after rendering
  useEffect(() => {
    if (!state.auth.isLoading && window.location.pathname === "/") {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
    }
  }, [state.auth.isLoading, dispatch]);

  // 1. Show spinner while loading auth data
  if (state.auth.isLoading) {
    return <LoadingSpinner />;
  }

  // 2. Show spinner if we are waiting for the entryPage state to populate
  if (state.auth.entryPage == null) {
    return <LoadingSpinner />;
  }

  // 3. Once we have the entry page, navigate away
  if (state.auth.entryPage === "/") {
    return <Navigate to="/dashboard" />;
  }

  return <Navigate to={state.auth.entryPage} />;
}

// Extracted spinner to keep your code DRY (Don't Repeat Yourself)
function LoadingSpinner() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        backgroundColor: "white",
        marginTop: "46vh",
      }}
    >
      <CircularProgress />
    </div>
  );
}

export default Loader;
